var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_vm.rootTag, { tag: "component", staticClass: "root" }, [
    _c("div", { staticClass: "col", style: _vm.parentStyle }, [
      _vm.imageUrl
        ? _c("img", {
            attrs: { src: _vm.imageUrl, alt: "Custom image on dashboard" },
          })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }